import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'
import createCustomersWatcher from 'store/plugins/customersWatcher'

const _isFalsy = (val) =>
  _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = (val) => !_isFalsy(val)

const customers = {
  namespaced: true,

  state: {
    // used from `/customers`
    paginatedList: [],
    currentPage: 0,
    prospects: true,
    searchFilters: {
      structures: [],
      products: [],
      agencies: [],
      customer_status: "",
      package: false,
      postal_proxy: false,
      mailbox_suspended: false,
      redirection: false,
      sap_promo_code: ""
    },
    sortParams: {
      orderBy: "created_at",
      sortedBy: "desc",
    },

    prospectsList: null,

    // used to get a specific customer data `/customer/{id}`
    customer: null,

  },

  mutations: {
    [types.CUSTOMERS_PAGE_RECEIVED](state, payload) {
      // NOTE: protip: (from 2ality)
      // other ways to achieve the same array init as in line 23
      // Array.from(Array(300), _ => ({}))
      // Array(300).fill({})
      // debugger
      if (_.isEmpty(state.paginatedList) ||
        state.paginatedList[state.currentPage].last_page !== payload.last_page)
        state.paginatedList = _.range(payload.last_page - 1).map(() => ({}))
      Vue.set(state.paginatedList, payload.current_page - 1, payload)
    },

    [types.CUSTOMERS_CURRENT_PAGE_CHANGED](state, value) {
      state.currentPage = value
    },

    [types.CUSTOMERS_FILTERS_CHANGED](state, filters) {
      state.searchFilters = _.assign({}, state.searchFilters, filters)
      // OMG
      state.paginatedList = []
      state.currentPage = 0
    },

    [types.CUSTOMER_RECEIVED](state, payload) {
      state.customer = payload
    },

    PROSPECTS_RECEIVED(state, payload) {
      state.prospectsList = payload
    }
  },

  actions: {
    getCustomersPage({ commit, state, rootState, getters }, { idx = false } /* optional */) {
      //console.log( getters.userAgenciesIdList)
      // internal index is 0-based while API's one is 1-based
      // debugger
      const internalIndex = idx === false ?
        state.currentPage + 1 : idx + 1,
        prospects = state.prospects,
        otherParams = _.assign(
          {}, 
          {
            validated: !prospects,
            with: "contracts.proxies.type;representatives"
          }, 
          getters.normalizedSearchFilters,
          state.sortParams
        )
        
      // if data is in cache => only changing current page
      // if (!_.isEmpty(state.paginatedList[internalIndex]))
      //   return commit(types.CUSTOMERS_CURRENT_PAGE_CHANGED, internalIndex)
      // no data => fetching page from API
      return api.getCustomers(internalIndex, otherParams).then(response => {
        //console.log(response.data)
        // puting raw data in cache
        commit(types.CUSTOMERS_PAGE_RECEIVED, response.data)
        commit(types.CUSTOMERS_CURRENT_PAGE_CHANGED, internalIndex - 1)
      })
    },

    getProspects({ commit }) {
      return api.getProspects()
        .then(response => {
          commit('PROSPECTS_RECEIVED', response.data.customers)
        })
    },

    updateFilters({ commit, dispatch, state }, filters) {
      commit(types.CUSTOMERS_FILTERS_CHANGED, filters)
      dispatch('getCustomersPage', { idx: state.currentPage })
    }
  },

  getters: {
    currentCustomers(state) {
      return state.paginatedList[state.currentPage]
    },

    someCustomers(state, getters) {
      return !_.isEmpty(getters.currentCustomers)
    },

    totalPages(state, getters) {
      return (getters.someCustomers) ?
        getters.currentCustomers.last_page : 0
    },

    userAgenciesIdList(state, getters, rootState) {
      return _.map(
        rootState.user.agencies,
        (agency) => "" + agency.id
      )
    },

    selectProspectsList(state) {
      return _.map(state.prospectsList, (prospect) => ({
        id: prospect.id,
        text: prospect.name + (prospect.trade_name ? ` (${prospect.trade_name})` : '')
      }))
    },

    selectAgenciesList(state, getters, rootState) {
      return _.chain(rootState.agencies)
        .filter(['archived', false])
        .map(
        (agency) => ({
          id: agency.id,
          text: agency.display_name
        })
        ).value()
    },

    normalizedSearchFilters(state, getters) {
      return _.pickBy(
        state.searchFilters,
        _isValid
      )
    }
  }
}

export default customers



// WEBPACK FOOTER //
// ./client/store/modules/prospects.js